import React, { useState } from "react";
import { CgSpinner } from "react-icons/cg";
import { useSelector, useDispatch } from "react-redux";
import { CiEdit } from "react-icons/ci";
import { AiFillCloseCircle } from "react-icons/ai";
import { AiFillCheckCircle } from "react-icons/ai";
import { checkAccessFn } from "../../../../../utils/checkAccess";
import useSearchPagination from "../../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { axios } from "../../../../../Global";
import { setAppError } from "../../../../../store/userSlice";
import Highlighter from "react-highlight-words";

export default function ListDataRateCategoryItems({
  list = [],
  editData,
  showCategoryItems,
  deleteData,
  loading,
  listLoading,
  setUpdated,
  column = 5,
  titles = [],
}) {
  const dashboardData = useSelector((state) => state.dashboardData);
  const token = localStorage.getItem("token");
  const [editCost, setEditCost] = useState({ open: false, id: "" });
  const [costValue, setCostValue] = useState("");
  const dispatch = useDispatch();
  const checkAccess = (module, name) =>
    checkAccessFn(dashboardData, module, name);

  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(list);

  const onToggleUpdate = async (value, id, type) => {
    if (
      (type == "Actual" && value == false) ||
      (type == "12 Months" && value == false) ||
      (type == "24 Months" && value == false)
    ) {
      return;
    }

    try {
      const body = {
        type: type,
      };
      const res = await axios.put(`/dashboard/rate-category-item/${id}`, body, {
        headers: { Authorization: `Bearer ${token}` },
      });
      if (res.status == 200) {
        dispatch(
          setAppError({
            msg: res?.data?.message,
            color: "success",
          })
        );
        setCostValue("");
        setEditCost({ open: false, id: "" });
        setUpdated((prev) => !prev);
      }
    } catch (error) {
      dispatch(
        setAppError({
          msg: error.message,
        })
      );
    }
  };

  const [searchWords, setSearchWords] = useState([]);

  const onCostUpdate = async (prevCost, id) => {
    if (prevCost !== costValue && costValue !== "") {
      try {
        const res = await axios.put(
          `/dashboard/rate-category-item/${id}`,
          { cost: costValue },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (res.status == 200) {
          dispatch(
            setAppError({
              msg: res?.data?.message,
              color: "success",
            })
          );
          setEditCost({ open: false, id: "" });
          setUpdated((prev) => !prev);
        }
      } catch (error) {
        dispatch(
          setAppError({
            msg: error.message,
          })
        );
      }
    } else {
      setEditCost({ open: false, id: "" });
    }
  };

  console.log("current", currentList);

  return (
    <div className="p-5">
      <div className="flex md:flex-row flex-col  justify-between items-end">
        <Search searchKey={["name", "cost"]} setSearchWords={setSearchWords} />
        <p className="text-sm w-full text-right font-medium mb-1 xl:hidden block">{`Slide / scroll to right >`}</p>
        <CountPerPage />
      </div>
      <div
        className={`grid grid-cols-table-7  auto-cols-min gap-5 p-6 bg-white w-full overflow-x-scroll lg:overflow-auto items-baseline  rounded-md `}
      >
        {titles.map((t, index) => (
          <p key={index} className="font-semibold uppercase">
            {t}
          </p>
        ))}
        {listLoading && (
          <div className="flex justify-center items-center gap-3 mt-5 w-full col-span-7">
            <p>Loading</p>
            <CgSpinner className="animate-spin" />
          </div>
        )}
        {!listLoading && <NoDataFound />}
        {!listLoading &&
          currentList.map((list, index) => (
            <React.Fragment key={index}>
              <PaginationIndex index={index} />
              <p>
                <Highlighter
                  searchWords={searchWords}
                  autoEscape={true}
                  textToHighlight={list.name || "-"}
                />
              </p>
              {editCost.open && editCost.id == list?.id ? (
                <input
                  defaultValue={list.cost}
                  className="border border-slate-200 w-44 rounded focus:border-slate-200 py-1 px-2 bg-slate-100"
                  type="number"
                  placeholder="Enter cost"
                  autoFocus={true}
                  onChange={(e) => setCostValue(e.target.value)}
                />
              ) : (
                <p
                  className={
                    list?.name == "GOSI" ||
                    list?.name == "END OF SERVICE" ||
                    list?.name == "VACATION SALARY"
                      ? "text-sm "
                      : ""
                  }
                >
                  <Highlighter
                    searchWords={searchWords}
                    autoEscape={true}
                    textToHighlight={list.cost || "-"}
                  />
                </p>
              )}
              {list?.name !== "GOSI" &&
              list?.name !== "END OF SERVICE" &&
              list?.name !== "VACATION SALARY" ? (
                <div>
                  <input
                    type="checkbox"
                    className="toggle toggle-error"
                    name="Actual"
                    onChange={(e) => {
                      onToggleUpdate(e.target.checked, list?.id, "Actual");
                    }}
                    checked={list?.type === "Actual" ? true : false}
                  />
                </div>
              ) : (
                <p>---</p>
              )}

              {list?.name !== "GOSI" &&
              list?.name !== "END OF SERVICE" &&
              list?.name !== "VACATION SALARY" ? (
                <div>
                  <input
                    type="checkbox"
                    className="toggle toggle-error"
                    onChange={(e) => {
                      onToggleUpdate(e.target.checked, list?.id, "12 Months");
                    }}
                    checked={list?.type === "12 Months" ? true : false}
                  />
                </div>
              ) : (
                <p>---</p>
              )}

              {list?.name !== "GOSI" &&
              list?.name !== "END OF SERVICE" &&
              list?.name !== "VACATION SALARY" ? (
                <div>
                  <input
                    type="checkbox"
                    className="toggle toggle-error"
                    onChange={(e) => {
                      onToggleUpdate(e.target.checked, list?.id, "24 Months");
                    }}
                    checked={list?.type === "24 Months" ? true : false}
                  />
                </div>
              ) : (
                <p>---</p>
              )}

              {list?.name !== "GOSI" &&
              list?.name !== "END OF SERVICE" &&
              list?.name !== "VACATION SALARY" ? (
                <>
                  {editCost.open && editCost.id == list?.id ? (
                    <div>
                      <button
                        className="p-1 px-2 rounded-md  mr-2 bg-red text-white "
                        onClick={() => onCostUpdate(list?.cost, list.id)}
                      >
                        <AiFillCheckCircle className="" size={"1.4rem"} />
                      </button>
                      <button
                        className="p-1 px-2 rounded-md  bg-black text-white "
                        onClick={() => setEditCost(false)}
                      >
                        <AiFillCloseCircle className="" size={"1.4rem"} />
                      </button>
                    </div>
                  ) : (
                    <>
                      {checkAccess(
                        "Rate Category",
                        "rate-category-item-edit"
                      ) && (
                        <button
                          className={
                            listLoading || currentList?.length <= 0
                              ? "p-1 px-2 w-fit rounded-md ring-1 ring-slate-900 opacity-50"
                              : "p-1 px-2 w-fit rounded-md ring-1 ring-slate-900 "
                          }
                          onClick={() => {
                            setCostValue("");
                            setEditCost({ open: true, id: list?.id });
                          }}
                          disabled={listLoading || currentList?.length <= 0}
                        >
                          <CiEdit size={"1.4rem"} />
                        </button>
                      )}
                    </>
                  )}
                </>
              ) : (
                <p>---</p>
              )}

              <hr
                className={`border-[1.5px] border-slate-100  w-full col-span-7 `}
              />
            </React.Fragment>
          ))}
      </div>
      <Pagination />
    </div>
  );
}
